import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useMemo, useCallback } from "react";
import Col from "../Grid/Col.js";
import classnames from "../../utils/classnames.js";
import Row from "../Grid/Row.js";
import './LocationSelect.css';import '../Grid/Grid.css';/* empty css                */
import Input2 from "../Input/Input.js";
import Typography from "../Typography/Typography.js";
/* empty css                    */
const getStyledOption = (filter, option) => {
  const { name } = option;
  if (!name.toLowerCase().startsWith(filter.toLowerCase())) {
    return /* @__PURE__ */ jsx(Typography.Link, { title: name, level: "small", color: "darkest", children: name });
  }
  const filterLength = filter.length;
  const matchedText = name.substring(0, filterLength);
  const otherText = name.substring(filterLength);
  return /* @__PURE__ */ jsxs(Typography.Link, { title: name, level: "small", color: "darkest", children: [
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", children: matchedText }),
    otherText
  ] });
};
const LocationList = ({ items, onSelect, label, placeholder, selected, errorMessage }) => {
  const [filter, setFilter] = useState("");
  const [error, setError] = useState(false);
  const filteredItems = useMemo(
    () => items.filter((item) => item.name.toUpperCase().includes(filter.toUpperCase())),
    [items, filter]
  );
  const handleSearchClick = useCallback(() => {
    if (filter && !filteredItems.length) {
      setError(true);
    }
  }, [filteredItems.length, filter]);
  const onChangeFilter = (e) => {
    setFilter(e.target.value);
    setError(false);
  };
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-location-list"), children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
      Input2,
      {
        value: filter,
        placeholder,
        onChange: onChangeFilter,
        className: classnames("perxis-auto-location-list__search"),
        allowClear: true,
        status: error ? "error" : void 0,
        onClear: () => setError(false),
        onPressEnter: handleSearchClick
      }
    ) }),
    error && /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-location-list__error"), children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "light-colorful", children: errorMessage }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-location-list__list"), children: filteredItems.map((item) => {
      const isSelected = (selected == null ? void 0 : selected.id) === item.id;
      return /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "small",
          onClick: () => {
            setFilter("");
            onSelect(item);
          },
          className: classnames([
            "perxis-auto-location-list__list-item",
            {
              [`perxis-auto-location-list__list-item-selected`]: isSelected
            }
          ]),
          children: getStyledOption(filter, item)
        },
        item.id
      );
    }) }) })
  ] }) });
};
export {
  LocationList as default
};
//# sourceMappingURL=LocationList.js.map
